export const DUPLICATE_CARD_MESSAGE = 'Kortelė su šiuo ID jau egzistuoja';
export const DISCOUNT_RANGE_ERROR =
  'Galiojimo pabaiga turi būti vėlesnė už pradžią';

const toTimestamp = (date, time, fallbackTime) => {
  if (!date) return null;
  return new Date(`${date}T${time || fallbackTime}`).getTime();
};

export const validateDiscountAssignmentForm = (
  values = {},
  { requirePlan = true } = {}
) => {
  const errors = {};

  if (!values.membership_id) {
    if (requirePlan) {
      errors.membership_id = 'Pasirinkite nuolaidos planą';
    }
    return errors;
  }

  if (!values.discount_valid_from) {
    errors.discount_valid_from = 'Įveskite nuolaidos galiojimo pradžią';
  }

  const fromTs = toTimestamp(
    values.discount_valid_from,
    values.discount_valid_from_time,
    '00:00'
  );
  const toTs = toTimestamp(
    values.discount_valid_to,
    values.discount_valid_to_time,
    '23:59'
  );

  if (fromTs != null && toTs != null && toTs <= fromTs) {
    errors.discount_valid_to = DISCOUNT_RANGE_ERROR;
  }

  return errors;
};

export const validatePhysicalCardForm = (values = {}, options = {}) => {
  const errors = {};
  const mode = options.mode || 'create';
  const number = (values.number || '').trim();

  if (mode === 'create') {
    if (!number) {
      errors.number = 'Įveskite kortelės ID';
    } else if (options.isDuplicate) {
      errors.number = DUPLICATE_CARD_MESSAGE;
    }

    if (values.initial_balance !== '' && values.initial_balance != null) {
      const balance = Number(values.initial_balance);
      if (Number.isNaN(balance) || balance < 0) {
        errors.initial_balance = 'Pradinis likutis turi būti 0 arba daugiau';
      }
    }

    Object.assign(
      errors,
      validateDiscountAssignmentForm(values, { requirePlan: false })
    );
  }

  if (!values.owner_type) {
    errors.owner_type = 'Pasirinkite savininko tipą';
  }

  if (!values.owner_id) {
    errors.owner = 'Pasirinkite savininką';
  }

  if (values.status === '' || values.status == null) {
    errors.status = 'Pasirinkite statusą';
  }

  return errors;
};

export const hasValidationErrors = errors =>
  Object.keys(errors || {}).length > 0;
